if (!customElements.get('cairo-stock-popup')) {
  customElements.define('cairo-stock-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.section = document.getElementById(this.dataset.sectionId);
      this.shownVariants = new Set();
      this.onChange = this.handleChange.bind(this);
      this.section?.addEventListener('change', this.onChange);
      this.showIfUnavailable(this.dataset.variantId, this.dataset.stockState);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onChange);
      this.request?.abort();
      this.dialog.close();
    }

    showIfUnavailable(variantId, state) {
      if (state !== 'unavailable' || this.shownVariants.has(variantId)) return;
      this.dialog.showModal();
      this.shownVariants.add(variantId);
    }

    async handleChange(event) {
      // The theme dispatches this after resolving the selected size/color.
      if (event.target.name !== 'id' || event.target.form?.id !== this.dataset.formId) return;
      const variantId = event.target.value;
      if (!variantId || variantId === this.dataset.variantId) return;
      this.dataset.variantId = variantId;
      this.request?.abort();
      this.dialog.close();
      const request = new AbortController();
      this.request = request;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const popup = html.querySelector('cairo-stock-popup');
        if (!this.isConnected || request.signal.aborted || popup?.dataset.variantId !== variantId) return;
        this.showIfUnavailable(variantId, popup.dataset.stockState);
      } catch (error) {
        // Missing availability data must not be presented as confirmed zero stock.
        if (error.name !== 'AbortError') console.warn('Could not check Cairo availability.');
      }
    }
  });
}
